const GET_COUNT = 'react-template/notifications/GET_COUNT'
const GET_COUNT_SUCCESS = 'react-template/notifications/GET_COUNT_SUCCESS'
const GET_COUNT_FAIL = 'react-template/notifications/GET_COUNT_FAIL'

const LOAD_NOTIFICATIONS = 'react-template/notifications/LOAD_NOTIFICATIONS'
const LOAD_NOTIFICATIONS_SUCCESS = 'react-template/notifications/LOAD_NOTIFICATIONS_SUCCESS'
const LOAD_NOTIFICATIONS_FAIL = 'react-template/notifications/LOAD_NOTIFICATIONS_FAIL'

const MARK_AS_READ_BULK = 'react-template/notifications/MARK_AS_READ_BULK'
const MARK_AS_READ_BULK_SUCCESS = 'react-template/notifications/MARK_AS_READ_BULK_SUCCESS'
const MARK_AS_READ_BULK_FAIL = 'react-template/notifications/MARK_AS_READ_BULK_FAIL'

const initialState = {
  loaded: false,
  loading: false,
  count: null,
  markAsRead: null
}

export default function notifications(state = initialState, action = {}) {
  switch (action.type) {
    case GET_COUNT:
      return {
        ...state,
        loading: true
      }

    case GET_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        count: action.result
      }

    case GET_COUNT_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }

    case LOAD_NOTIFICATIONS:
      return {
        ...state,
        loading: true
      }

    case LOAD_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        data: action.result
      }

    case LOAD_NOTIFICATIONS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case MARK_AS_READ_BULK:
      return {
        ...state,
        loading: true
      }

    case MARK_AS_READ_BULK_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        markAsRead: action.result
      }

    case MARK_AS_READ_BULK_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}

export function loadCount() {
  return {
    types: [GET_COUNT, GET_COUNT_SUCCESS, GET_COUNT_FAIL],
    promise: client =>
      client.get('api/notifications/count?isCalledFromWeb=true')
  }
}

export function loadNotifications() {
  return {
    types: [
      LOAD_NOTIFICATIONS,
      LOAD_NOTIFICATIONS_SUCCESS,
      LOAD_NOTIFICATIONS_FAIL
    ],
    promise: client =>
      client.get('api/notifications?isCalledFromWeb=true&sort=-creationDate&with=ACTIVITY_LOG,AUTHOR')
  }
}

export function markAsReadBulk(data) {
    return {
      types: [
        MARK_AS_READ_BULK,
        MARK_AS_READ_BULK_SUCCESS,
        MARK_AS_READ_BULK_FAIL
      ],
      promise: client =>
        client.post('api/notifications/mark-as-read/bulk', { data })
    }
}
